import { forwardRef, type ReactNode } from 'react';

/**
 * The app-like frame every table session lives in: height-locked to the viewport below the
 * sticky header (the same `.problems-scroll-height` math /problems uses), so the whole table
 * stays in view and any overflow scrolls inside this container — never the document.
 *
 * `.problems-scroll` is a flex column, which is what lets the felt inside stretch to the bottom
 * with `flex-1`. Wrap the transient states (loading, error, finished) in it too, so they occupy
 * the same locked frame as the table and the page never changes height between them.
 *
 * This is also the surface-theme application point: a session on a different felt puts its theme
 * class here (`<SessionViewport className="surface-mastery">`) and every `bg-felt*` inside —
 * frame, masthead, page background — retunes with it. See the surface-theme block in index.css.
 */
export const SessionViewport = forwardRef<HTMLDivElement, { className?: string; children: ReactNode }>(
  function SessionViewport({ className, children }, ref) {
    return (
      <div
        ref={ref}
        className={`problems-scroll problems-scroll-height scrollable${className ? ` ${className}` : ''}`}
      >
        {children}
      </div>
    );
  },
);
